<script lang="ts">
    
    import { onMount } from "svelte";
    import { Link } from "svelte-navigator";
    import { Table, Modal, ModalHeader, ModalBody, Button, Icon, Row, Col, InputGroup, InputGroupText } from "sveltestrap";
    import AccountForm from "../../Components/Accounts/AccountForm.svelte";
    import AllowedGamesTags from "../../Components/Accounts/AllowedGamesTags.svelte";
    import AppWrapper from "../../Components/AppWrapper.svelte";
    import DisabledBadge from "../../Components/Shared/DisabledBadge.svelte";
    import EnabledBadge from "../../Components/Shared/EnabledBadge.svelte";
    import TitleBar from "../../Components/TitleBar.svelte";
    import Watch from "../../Components/Watch.svelte";
    import type { Account } from "../../Model/Account";
    import { accountsFactory, accountsService, uuidGenerator } from "../../Services";

    let accounts: Account[] = [];
    let filteredAccounts: Account[] = [];
    let openAccountModal = false;
    let editAccount: Account;
    let searchString = '';
    let filterTimeout: number;

    onMount(getAccounts);

    async function getAccounts(): Promise<void> {
        accounts = await accountsService.getAccounts();
        sortAccounts();
        filterAccounts();
    }

    function sortAccounts(): void {
        accounts.sort((a, b) => {
            return a.name.value < b.name.value ? -1 : 1;
        });
    }

    function onCreateAccount(): void {
        editAccount = accountsFactory.createAccount(uuidGenerator.createUuid(), true, '', []);
        openAccountModal = true;
    }

    function toggleAccountModal(): void {
        openAccountModal = !openAccountModal;
    }

    function onAccountSaved(): void {
        if (!accounts.some(({ id }) => id === editAccount.id)) {
            accounts = [editAccount, ...accounts];
        }
        openAccountModal = false;
        sortAccounts();
        filterAccounts();
    }

    function onSearchInput(): void {
        window.clearTimeout(filterTimeout);
        filterTimeout = window.setTimeout(filterAccounts, 300);
    }

    function filterAccounts(): void {
        if (!searchString) {
            filteredAccounts = accounts;
            return;
        }
        const regexp = new RegExp(searchString, 'i');
        filteredAccounts = accounts.filter(({ name }) => {
            return regexp.test(name.value);
        });
    }

</script>

<AppWrapper>

    <TitleBar title="Cuentas">
       <Button type="button" color="primary" on:click={onCreateAccount}>
           <Icon name="plus" /> Añadir cuenta
       </Button>
    </TitleBar>

    <Row class="mb-3">
        <Col lg={6}>
            <InputGroup>
                <InputGroupText>
                    <Icon name="search" />
                </InputGroupText>
                <input
                    type="search"
                    class="form-control"
                    bind:value={searchString}
                    on:input={onSearchInput}
                    placeholder="Buscar cuentas">
            </InputGroup>
        </Col>
    </Row>

    <Table>
        <thead>
            <tr>
                <th>Nombre</th>
                <th>Juegos permitidos</th>
                <th>Estado</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {#each filteredAccounts as account}
            <tr>
                <td>
                    <Watch state={account.name} let:value>
                        <Link to={`editar/${account.id}`}>{value}</Link>
                    </Watch>
                </td>
                <td>
                    <AllowedGamesTags allowedGames={account.allowedGames} />
                </td>
                <td>
                    <Watch state={account.enabled} let:value>
                        {#if value}
                            <EnabledBadge text="Activada" />
                        {:else}
                            <DisabledBadge text="Desactivada" />
                        {/if}
                    </Watch>
                </td>
                <td class="text-end">
                    <Link to={`editar/${account.id}`} class="btn btn-primary btn-sm">
                        <Icon name="pencil" />
                    </Link>
                </td>
            </tr>
            {/each}
        </tbody>
    </Table>

</AppWrapper>

<Modal isOpen={openAccountModal}>
    <ModalHeader toggle={toggleAccountModal}>
        Editar cuenta
    </ModalHeader>
    <ModalBody>
        <AccountForm account={editAccount} on:saved={onAccountSaved} />
    </ModalBody>
</Modal>
